// Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Vue
import { createApp } from 'vue'
import KnowledgebasePage from '@components/KnowledgebasePage.vue'

// Vuetify configuration
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
  },
})

// Mount KnowledgebasePage to #knowledgebase-app mount point
function mountKnowledgebaseApp() {
  const el = document.getElementById('knowledgebase-app')
  if (el && !el.__vue_app__) {
    // Get data attributes passed from Rails
    const categoriesData = el.dataset.categories ? JSON.parse(el.dataset.categories) : []
    const translations = el.dataset.translations ? JSON.parse(el.dataset.translations) : {}
    const pageTitle = el.dataset.pageTitle || 'Knowledge Base'
    const breadcrumbsData = el.dataset.breadcrumbs ? JSON.parse(el.dataset.breadcrumbs) : []
    const locale = window.location.pathname.split('/')[1] || 'en'
    const knowledgebasePath = el.dataset.knowledgebasePath || '/' + locale + '/knowledgebase'
    const searchPath = el.dataset.searchPath || '/' + locale + '/result'

    const app = createApp(KnowledgebasePage, {
      categoriesData,
      translations,
      pageTitle,
      breadcrumbsData,
      knowledgebasePath,
      searchPath
    })

    app.use(vuetify)
    app.mount('#knowledgebase-app')
  }
}

// Mount on DOM ready (for initial page load)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountKnowledgebaseApp)
} else {
  mountKnowledgebaseApp()
}

// For Turbolinks support
document.addEventListener('turbolinks:load', mountKnowledgebaseApp)

// Clean up on Turbolinks navigation
document.addEventListener('turbolinks:before-visit', () => {
  const el = document.getElementById('knowledgebase-app')
  if (el && el.__vue_app__) {
    el.__vue_app__.unmount()
    delete el.__vue_app__
  }
})
